import React, { FC, useCallback } from 'react';
import * as actions from '../mfaTokensActions';
import { Field } from '../types';
import UserIdentifierDropdown from './UserIdentifierDropdown';
import TokenTextField from './TokenTextField';
import { RSA_MFA_TOKEN_FIELDS } from '../../../common/fields';
import TokenActions from './TokenActions';
import { TokenComponentProps } from './index';

type DispatchFn = (action: UpdateAction) => void;

interface UpdateAction {
    type: typeof actions.UPDATE_RSA_MFA_TOKEN;
    payload: {
        fieldId: string;
        value: string;
    };
}

export interface RsaFields {
    rsaUpnField: Field;
    rsaRestEndpoint: Field;
    rsaApiKey: Field;
}

export type RsaProps = TokenComponentProps<RsaFields, DispatchFn>;

const Rsa: FC<RsaProps> = ({ fields, dispatch, onSave, onCancel }) => {
    const rsaUpn = fields[RSA_MFA_TOKEN_FIELDS.RSA_UPN_FIELD.ID];
    const rsaRestEndpoint = fields[RSA_MFA_TOKEN_FIELDS.RSA_REST_ENDPOINT.ID];
    const rsaApikey = fields[RSA_MFA_TOKEN_FIELDS.RSA_API_KEY.ID];

    const isSomeFieldsEmpty = [rsaRestEndpoint, rsaApikey].some((field) => !field.value);

    const textFields = [
        { field: rsaRestEndpoint, isSecret: false, placeholder: 'rsaready.auth-demo.secureid.com' },
        { field: rsaApikey, isSecret: true, placeholder: 'Enter key' }
    ];

    const dispatchUpdate = useCallback(
        (fieldId: string, value: string) => {
            dispatch({
                type: actions.UPDATE_RSA_MFA_TOKEN,
                payload: { fieldId, value }
            });
        },
        [dispatch]
    );

    const rsaUpnOptions = (rsaUpn.options || []).map((option) => ({
        title: option.label,
        value: option.value
    }));

    return (
        <>
            <UserIdentifierDropdown
                options={rsaUpnOptions}
                selectedOption={rsaUpn.value}
                onChange={(val) => dispatchUpdate(rsaUpn.id, val)}
                mandatory
                label={rsaUpn.name}
            />

            {textFields.map(({ field, isSecret, placeholder }) => (
                <TokenTextField
                    key={field.id}
                    label={field.name}
                    value={field.value}
                    isSecret={isSecret}
                    placeholder={placeholder}
                    onChange={(val) => dispatchUpdate(field.id, val)}
                />
            ))}
            <TokenActions onSave={onSave} onCancel={onCancel} saveDisabled={isSomeFieldsEmpty} />
        </>
    );
};

export default Rsa;
